import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";

interface VideoCardProps {
  item: VideoItem;
  showTypeBadge?: boolean;
}

export default function VideoCard({ item, showTypeBadge = false }: VideoCardProps) {
  return (
    <Link to={`/detail/${item.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-secondary-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - ${item.category}影视资源在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
        <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded text-xs font-semibold bg-accent-500 text-white">
          {item.rating.toFixed(1)}
        </span>
        {item.type === "tv" && item.status && (
          <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded text-xs font-medium bg-primary-600/90 text-white">
            {item.status}
          </span>
        )}
        {showTypeBadge && (
          <span className="absolute bottom-2 left-2 px-1.5 py-0.5 rounded text-xs font-medium bg-secondary-900/70 text-white">
            {item.type === "movie" ? "电影" : "电视剧"}
          </span>
        )}
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-white">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </span>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {item.category} · {item.region} · {item.year}
        </p>
      </div>
    </Link>
  );
}